import Cookies from "universal-cookie";
import $ from "jquery";
import moment from "moment";

import { toast } from "react-toastify";
import { getApi, getHeaders, postApi } from "./apiHelper";
import apiRoutes, { withdrawalLocations } from "./apiRoutes";
const { REACT_APP_API_URL, REACT_APP_CALLBACK_URL, REACT_APP_DECRYPT_KEY } =
  process.env;
const CryptoJS = require("crypto-js");

const main_url = REACT_APP_API_URL;
const remote_url = REACT_APP_CALLBACK_URL;
const decrypt_key = REACT_APP_DECRYPT_KEY;

const limit_amounts = {
  default: 1500000,
  travel: {
    base: 1000000,
    top: 2000000,
  },
  hospitalization: {
    base: 1000000,
    top: 3000000,
  },
};

const alertText = "Please complete all required fields.";

const MARITAL_STATUS_OPTIONS = [
  { label: "Unmarried", value: "Unmarried" },
  { label: "Married", value: "Married" },
  { label: "Divorced", value: "Divorced" },
  { label: "Widowed", value: "Widowed" },
];

const cookies = new Cookies();

const fno = {
  //form number
  //allowance
  fno_travel: "TR",
  fno_training: "TA",
  fno_phone: "PH",
  fno_petrol: "PE",
  fno_salary: "SA",

  //staff loan
  fno_staff_loan: "SL",

  fno_announce: "AN",

  //benefit
  fno_wedding: "WB",
  fno_child: "CB",
  fno_funeral: "FB",
  fno_external: "ET",
  fno_medical: "MB",
  fno_birthday: "BF",
  fno_team: "TB",
  fno_other: "OB",
  fno_hospital: "HP",
  fno_cycle: "CI",
  // fno_staff_loan: "SL",
};

async function calculationWorkingExp(startDate, endDate) {
  const date1 = new Date(startDate);
  const date2 = new Date(endDate);
  const diffInMs = Math.abs(date2 - date1);
  const noOfDays = diffInMs / (1000 * 60 * 60 * 24);
  let years = Math.floor(noOfDays / 365);
  let months = Math.floor((noOfDays % 365) / 30);
  let days = Math.floor((noOfDays % 365) % 30);
  let formatMonth = Math.floor(noOfDays / 30);
  let formatYear =
    years == 0
      ? months + " months "
      : years + " years " + parseInt(months) + " months ";
  let returnData = formatYear;
  return returnData;
}

// function getFirstDayOfNextMonth(a) {
//     const date = new Date(a);
//     const day=date.getDay()

//     return new Date(date.getFullYear(), date.getMonth() + 1, day);
//   }
function getFirstDayOfNextMonth(a) {
  var date = new Date(a); // Now
  date.setDate(date.getDate() + 30);
  return date;
}

function getFirstDayOfNextTwoMonth(a) {
  var date = new Date(a); // Now
  date.setDate(date.getDate() + 60);
  return date;
}

function calculationDate(startDate, endDate) {
  var formatstartDate = new Date(startDate);
  var formatendDate = new Date(endDate);
  // console.log("calculationDate",formatstartDate,formatendDate)
  formatstartDate.setHours(0);
  formatstartDate.setMinutes(0);
  formatstartDate.setSeconds(0);
  formatstartDate.setMilliseconds(0);
  formatendDate.setHours(0);
  formatendDate.setMinutes(0);
  formatendDate.setSeconds(0);
  formatendDate.setMilliseconds(0);
  var timeDiff = Math.abs(
    formatendDate.getTime() - formatstartDate.getTime() + 1
  );
  var dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

  return dayDiff;
}

function getMonth(date) {
  const d = new Date(date);
  d.toLocaleString("en-US", { month: "short" });
}

function calculationDate1(startDate, endDate) {
  // Copy date objects so don't modify originals
  var s = new Date(startDate);
  var e = new Date(endDate);

  // Set time to midday to avoid dalight saving and browser quirks
  s.setHours(0, 0, 0, 0);
  e.setHours(0, 0, 0, 0);

  // Get the difference in whole days
  var totalDays = Math.round((e - s) / 8.64e7);
  console.log("total days ====================>", totalDays);

  // Get the difference in whole weeks
  var wholeWeeks = (totalDays / 7) | 0;

  // Estimate business days as number of whole weeks * 5
  var days = wholeWeeks * 5;
  // var days = 0;
  // If not even number of weeks, calc remaining weekend days
  if (totalDays % 7) {
    s.setDate(s.getDate() + wholeWeeks * 7);
    // if (wholeWeeks > 0) {
    //     while (s < e) {
    //         s.setDate(s.getDate() + 1);
    //         // If day isn't a Sunday or Saturday, add to business days
    //         if (s.getDay() != 0 && s.getDay() != 6) {
    //             ++days;
    //         }
    //     }
    // } else {
    while (s <= e) {
      // If day isn't a Sunday or Saturday, add to business days
      if (s.getDay() !== 0 && s.getDay() !== 6) {
        ++days;
      }
      s.setDate(s.getDate() + 1);
    }
    // }
  } else {
    days = days + 1;
  }
  console.log("datys is ===========>", days);
  return days;
}

async function calculationDate2(startDate, endDate) {
  const date1 = new Date(startDate);
  const date2 = new Date(endDate);

  const moment1 = moment(date1);
  const moment2 = moment(date2);

  const diffInMs = Math.abs(date2 - date1);
  const noOfDays = diffInMs / (1000 * 60 * 60 * 24);

  const years = moment2.diff(moment1, "years");
  let months = moment2.diff(moment1, "months") % 12;
  let days = date2.getDate() - date1.getDate();
  if (days < 0) {
    let dayCon = await getDay(date2);
    days = days + parseInt(dayCon);
    // months = months - 1
  }

  let formatMonth = Math.ceil(noOfDays / 30);

  let formatYear =
    years == 0
      ? months + " months " + days + " days "
      : years + " years " + months + " months " + days + " days ";
  // let returnData = [formatYear, formatMonth]
  let returnData = [formatYear, years == 0 ? months : formatMonth];
  return formatYear;
}

async function getDay(date) {
  let today = new Date(date);
  let firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  let lastDayOfPreviousMonth = new Date(firstDayOfMonth - 1);
  return moment(lastDayOfPreviousMonth).format("DD");
}

// for approve amount in cycle insurance

function approveAmount(reqAmount) {
  const amount = reqAmount / 2;
  if (amount < 100000) {
    return amount;
  }
  return 100000;
}

// function print(doc) {
//     doc.autoPrint();
//     window.open(doc.output('bloburl'), "_blank");
// }

function print(doc, data) {
  if (data != undefined) {
    const info = {
      ...data,
      print: 1,
    };

    if (data.print === 0) {
      let status = 0;
      if (data.travel_allowance_id != undefined) {
        fetch(main_url + "allowance/updatePrint/" + data.travel_allowance_id, {
          method: "PUT",
          headers: getHeaders(true),
          body: `info=${JSON.stringify(info)}`,
        })
          .then((res) => {
            status = res.status;
            return res.text();
          })
          .then((text) => {
            if (status === 200) {
              // alert("Printed!");
              window.location.reload();
            }
          });
      } else if (data.salary_advance_id != undefined) {
        fetch(
          main_url +
            "salary_advance/updatePrintSalary/" +
            data.salary_advance_id,
          {
            method: "PUT",
            headers: getHeaders(true),
            body: `info=${JSON.stringify(info)}`,
          }
        )
          .then((res) => {
            status = res.status;
            return res.text();
          })
          .then((text) => {
            if (status === 200) {
              // alert("Printed!");
              window.location.reload();
            }
          });
      } else if (
        data.benefit_id != undefined &&
        data.spouse_name != undefined
      ) {
        fetch(
          main_url + "wedding_benefit/printUpdateWedding/" + data.benefit_id,
          {
            method: "PUT",
            headers: getHeaders(true),
            body: `info=${JSON.stringify(info)}`,
          }
        )
          .then((res) => {
            status = res.status;
            return res.text();
          })
          .then((text) => {
            if (status === 200) {
              // alert("Printed!");
              window.location.reload();
            }
          });
      } else if (data.child_benefit_id != undefined) {
        fetch(
          main_url + "child_benefit/printUpdateChild/" + data.child_benefit_id,
          {
            method: "PUT",
            headers: getHeaders(true),
            body: `info=${JSON.stringify(info)}`,
          }
        )
          .then((res) => {
            status = res.status;
            return res.text();
          })
          .then((text) => {
            if (status === 200) {
              // alert("Printed!");
              window.location.reload();
            }
          });
      } else if (data.funeral_benefit_id != undefined) {
        fetch(
          main_url +
            "funeral_benefit/printUpdateFuneral/" +
            data.funeral_benefit_id,
          {
            method: "PUT",
            headers: getHeaders(true),
            body: `info=${JSON.stringify(info)}`,
          }
        )
          .then((res) => {
            status = res.status;
            return res.text();
          })
          .then((text) => {
            if (status === 200) {
              // alert("Printed!");
              window.location.reload();
            }
          });
      } else if (data.external_training_id != undefined) {
        fetch(
          main_url +
            "external_benefit/printUpdateExternal/" +
            data.external_training_id,
          {
            method: "PUT",
            headers: getHeaders(true),
            body: `info=${JSON.stringify(info)}`,
          }
        )
          .then((res) => {
            status = res.status;
            return res.text();
          })
          .then((text) => {
            if (status === 200) {
              // alert("Printed!");
              window.location.reload();
            }
          });
      } else if (data.medical_benefit_id != undefined) {
        fetch(
          main_url +
            "medical_benefit/printUpdateMedical/" +
            data.medical_benefit_id,
          {
            method: "PUT",
            headers: getHeaders(true),
            body: `info=${JSON.stringify(info)}`,
          }
        )
          .then((res) => {
            status = res.status;
            return res.text();
          })
          .then((text) => {
            if (status === 200) {
              // alert("Printed!");
              window.location.reload();
            }
          });
      } else if (data.birthday_benefit_id != undefined) {
        fetch(
          main_url +
            "birthday_benefit/printUpdateBirthday/" +
            data.birthday_benefit_id,
          {
            method: "PUT",
            headers: getHeaders(true),
            body: `info=${JSON.stringify(info)}`,
          }
        )
          .then((res) => {
            status = res.status;
            return res.text();
          })
          .then((text) => {
            if (status === 200) {
              // alert("Printed!");
              window.location.reload();
            }
          });
      } else if (data.benefit_id != undefined && data.quater_id != undefined) {
        fetch(
          main_url + "team_building/printUpdateTeamBuilding/" + data.benefit_id,
          {
            method: "PUT",
            headers: getHeaders(true),
            body: `info=${JSON.stringify(info)}`,
          }
        )
          .then((res) => {
            status = res.status;
            return res.text();
          })
          .then((text) => {
            if (status === 200) {
              // alert("Printed!");
              window.location.reload();
            }
          });
      } else if (data.other_benefit_id != undefined) {
        fetch(main_url + "benefit/printUpdateOther/" + data.other_benefit_id, {
          method: "PUT",
          headers: getHeaders(true),
          body: `info=${JSON.stringify(info)}`,
        })
          .then((res) => {
            status = res.status;
            return res.text();
          })
          .then((text) => {
            if (status === 200) {
              // alert("Printed!");
              window.location.reload();
            }
          });
      } else if (data.hospitalization_benefit_id != undefined) {
        fetch(
          main_url +
            "hospitalization_benefit/printUpdateHospitalization/" +
            data.hospitalization_benefit_id,
          {
            method: "PUT",
            headers: getHeaders(true),
            body: `info=${JSON.stringify(info)}`,
          }
        )
          .then((res) => {
            status = res.status;
            return res.text();
          })
          .then((text) => {
            if (status === 200) {
              // alert("Printed!");
              window.location.reload();
            }
          });
      } else if (data.cycle_insurance_benefit_id != undefined) {
        fetch(
          main_url +
            "cycleInsurance/printCycleInsurance/" +
            data.cycle_insurance_benefit_id,
          {
            method: "PUT",
            headers: getHeaders(true),
            body: `info=${JSON.stringify(info)}`,
          }
        )
          .then((res) => {
            status = res.status;
            return res.text();
          })
          .then((text) => {
            if (status === 200) {
              // alert("Printed!");
              window.location.reload();
            }
          });
      }
    }
    doc.autoPrint();
    window.open(doc.output("bloburl"), "_blank");
  } else {
    doc.autoPrint();
    window.open(doc.output("bloburl"), "_blank");
  }
}

function getFirstDayOfMonth() {
  var date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth();
  var firstDay = new Date(y, m, 1);
  return firstDay;
}
function getFirstDayOfCurrentWeek() {
  var d = new Date();
  var day = d.getDay(),
    diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
  return new Date(d.setDate(diff));
}
function getFirstDayOfYear() {
  var date = new Date(),
    y = date.getFullYear();
  var firstDay = new Date(y, 0, 1);
  return firstDay;
}
function getFirstDayOfPrevMonth() {
  var date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth();
  var firstDay = new Date(y, m - 2, 1);
  return firstDay;
}
function getLastDayOfMonth(y, m) {
  return new Date(y, m + 1, 0).getDate();
}

// Modify By STHA to Add decrypt method
async function getLoginUser(token) {
  // console.log("Here is in getLoginUser of Commonfunction.js 2222", id);
  var user = getCookieData("user_info");
  if (user && user.token) return user;

  user = await getUserInfoLogin(token);
  if (!user) return null;

  setCookieData("user_info", JSON.stringify(user));
  localStorage.setItem("user_id", user.user_id);
  return user;
}

// Anything thrown out of a login attempt ends up rendered on the login
// screen, so it has to be a string. fetch() rejects with a TypeError when the
// API is unreachable and res.json() throws when the body is not JSON -- both
// happen while the backend is restarting, and neither is a valid React child.
function getErrorMessage(err) {
  if (typeof err === "string") return err;
  if (err instanceof TypeError) {
    return "Cannot reach the server. Please check your connection and try again.";
  }
  if (err && typeof err.message === "string") return err.message;
  return "Something went wrong! Please try again later.";
}

async function handleLogin(employeeCode, password) {
  try {
    const res = await fetch(apiRoutes.login, {
      method: "post",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        SystemKey: process.env.REACT_APP_SYSTEM_KEY,
      },
      body: JSON.stringify({ employeeCode, password }),
    });
    let resData;
    try {
      resData = await res.json();
    } catch (parseErr) {
      throw "The server returned an unexpected response. Please try again later.";
    }

    if (!res.ok) {
      throw resData.message ?? "Something went wrong! Please try again later.";
    }
    const { data, token } = resData;
    if (data?.user && token) {
      setCookieData("user_info", JSON.stringify({ ...data.user, token }));
      localStorage.setItem("user_id", data.user.user_id);
      return data.user;
    } else throw "Something went wrong! Please try again later.";
  } catch (err) {
    throw err;
  }
}

//Added by STHA
async function setLoginUserInfo(data) {
  setCookieData("user_info", JSON.stringify(data));
}

// Added by STHA
async function getLoginUserInfo() {
  var user = await getCookieData("user_info");
  console.log("Here is in get User Info >>>>>>>>>>>>>>>>>...", user);

  if (user !== null) {
    localStorage.setItem("user_id", user.user_id);
  }
  return user;
}

async function getUserInfoLogin(ssoToken) {
  if (!ssoToken) return null;

  // Pass token from SSO to the login route and get back the jwt token and user data.
  const { data, token } = await postApi(
    apiRoutes.login,
    { token: ssoToken },
    false
  );
  if (data?.user && token) {
    return { ...data.user, token };
  } else return null;
}

async function getUserInfo(id) {
  var res = await fetch(`${main_url}main/getUserInfo/${id}`, {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return null;
}

async function getBranch() {
  var res = await fetch(`${main_url}main/getBranch`, {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}

async function getWithdrawalLocation() {
  const res = await getApi(withdrawalLocations);
  if (res && res.data) return res.data;
  return [];
}

//Added by STHA - 2023-12-08
async function getHRMSStatus(usage_type) {
  var res = await fetch(`${main_url}main/getHRMSStatus/${usage_type}`, {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}

async function getRegion() {
  var res = await fetch(`${main_url}benefit/getRegionList`, {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}
async function getPersonType() {
  var res = await fetch(`${main_url}main/getPersonType`, {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}
async function getTicketCategoryType() {
  var res = await fetch(`${main_url}main/getTicketCategoryType`, {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}

async function getDesignation() {
  var res = await fetch(`${main_url}permission/getDesignation`, {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}
async function getLevel() {
  var res = await fetch(`${main_url}main/getLevel`, {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}
// @lucy&kpk
// async function getEmployeeId() {
//     var res = await fetch(`${main_url}benefit/getEmployeeList`);
//     if (res.ok) return res.json();
//     else return [];
// }

function removeCookieData(name) {
  sessionStorage.removeItem("user_info");
  localStorage.clear();
  sessionStorage.clear();
  // cookies.remove(name);
}

function setCookieData(name, value) {
  var encrypt_text = CryptoJS.AES.encrypt(value, "encrypt");
  // cookies.set(name, value, { path: '/' });
  // var now = new Date();
  // var time = now.getTime();
  // time += 3 * 60 * 1000;
  // now.setTime(time);
  // document.cookie = name + "=" + encrypt_text + ";expires=" + now.toUTCString() + ";path=" + remote_url;
  sessionStorage.setItem(name, encrypt_text);
}

function getCookieData(name) {
  // var data = cookies.get(name);
  // if (data) {
  //     // data.replace('=', '');
  //     // data = JSON.parse(data);
  //     return data;
  // }
  // name = name + "=";
  // var decodedCookie = decodeURIComponent(document.cookie);
  // var ca = decodedCookie.split(';');
  // for (var i = 0; i < ca.length; i++) {
  //     var c = ca[i];
  //     while (c.charAt(0) === ' ') {
  //         c = c.substring(1);
  //     }
  //     if (c.indexOf(name) === 0) {
  //         var data = c.substring(name.length, c.length);
  //         var decrypt_text = CryptoJS.AES.decrypt(data, 'encrypt');
  //         data = JSON.parse(decrypt_text.toString(CryptoJS.enc.Utf8));
  //         return data;
  //     }
  // }
  // return null;
  var data = sessionStorage.getItem(name);
  if (data !== null) {
    var decrypt_text = CryptoJS.AES.decrypt(data, "encrypt");
    console.log("decrypt text", decrypt_text);

    data = JSON.parse(decrypt_text.toString(CryptoJS.enc.Utf8));
    console.log("json parse data", data);
  }
  return data;

  // return null;
}

function getUserId(name) {
  let user = getCookieData(name);
  if (user !== null) {
    let id = user.user_id;
    console.log("Here is user id in getUserId function >>>>>>>>>", id);
    if (id > 0) {
      return id;
    } else return 0;
  }
}

function isRequestedUser(updatedUser, createdUser) {
  if (updatedUser === createdUser) {
    return false;
  } else {
    return false;
  }
}

function getMainRole() {
  var data = sessionStorage.getItem("user_info");
  if (data !== null) {
    var decrypt_text = CryptoJS.AES.decrypt(data, "encrypt");
    data = JSON.parse(decrypt_text.toString(CryptoJS.enc.Utf8));
    if (data.role_id === 1 || data.role_id === 2 || data.role_id === 3)
      return true;
    else return false;
  }
  return false;
}

function checkApprovalStatus(dept, total_amount) {
  if (total_amount > limit_amounts.default && dept === "Head Office") {
    return true;
  } else {
    return false;
  }
}

async function checkForStaffComplain(id) {
  var res = await fetch(`${main_url}main/checkForStaffComplain/${id}`, {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}

async function getCOEmployeeList(id) {
  var res = await fetch(`${main_url}main/getCOEmployeeList/${id}`, {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}

async function getFXEmployeeList(id) {
  var res = await fetch(`${main_url}main/getFXEmployeeList/${id}`, {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}
async function getAttendanceReason() {
  var res = await fetch(`${main_url}attendance/fieldAttendanceReason`, {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}

function getActionStatus(status, data, createdBy, comment) {
  console.log("status title", status);
  var action = {
    referback_by: data.referback_by,
    checked_by: data.checked_by,
    verified_by: data.verified_by,
    approved_by: data.approved_by,
    rejected_by: data.rejected_by,
    referback_date: data.referback_date,
    checked_date: data.checked_date,
    verified_date: data.verified_date,
    approved_date: data.approved_date,
    rejected_date: data.rejected_date,
    referback_comment: data.referback_comment,
    checked_comment: data.checked_comment,
    verified_comment: data.verified_comment,
    approved_comment: data.approved_comment,

    status: data.status,
  };
  if (status === "referback") {
    action.referback_by = createdBy;
    action.referback_date = new Date();
    action.referback_comment = comment;
    action.status = 5;
  } else if (status === "checked") {
    action.checked_by = createdBy;
    action.checked_date = new Date();
    action.status = 1;
  } else if (status === "verified") {
    action.verified_by = createdBy;
    action.verified_date = new Date();
    action.status = 2;
  } else if (status === "approved") {
    action.approved_by = createdBy;
    action.approved_date = new Date();
    action.status = 3;
  } else if (status === "rejected") {
    if (action.status === 0) {
      action.checked_by = createdBy;
      action.verified_by = 0;
      action.approved_by = 0;
      action.checked_comment = comment;
    } else if (action.status === 1) {
      action.verified_by = createdBy;
      action.checked_by = 0;
      action.approved_by = 0;
      action.verified_comment = comment;
    } else if (action.status === 2) {
      action.approved_by = createdBy;
      action.verified_by = 0;
      action.checked_by = 0;
      action.approved_comment = comment;
    }

    action.rejected_by = createdBy;
    action.rejected_date = new Date();
    action.status = 4;
  }
  return action;
}

async function getTrainingVenue() {
  let res = await fetch(main_url + "allowance/getTrainingVenue", {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}
const FALLBACK_AVATAR = "/assets/img/SeekPng.com_profile-icon-png_9665493.png";

// Image MIME types keyed by file extension. The backend's getProfile route
// replies with the bare extension as its Content-Type (e.g. "jpg"), which is
// not a valid MIME type, so the blob is re-typed here before it is rendered.
const IMAGE_MIME_TYPES = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  bmp: "image/bmp",
  webp: "image/webp",
  svg: "image/svg+xml",
};

function imageError(e) {
  // Guard against an error loop: if the fallback itself fails to load, the
  // error event fires again on the same element.
  if (e.target.dataset.fallbackApplied) return;
  e.target.dataset.fallbackApplied = "1";
  e.target.src = FALLBACK_AVATAR;
}

// dashboard/getProfile is behind authController.protect, so the browser cannot
// load it directly from an <img src> -- that request carries no Authorization
// or SystemKey header and is rejected. Fetch it with the auth headers instead
// and hand back an object URL. Returns null when there is no photo to show;
// callers are responsible for revoking the URL on unmount.
async function fetchProfilePhoto(fileName) {
  if (!fileName) return null;
  try {
    const res = await fetch(main_url + `dashboard/getProfile/${fileName}`, {
      headers: getHeaders(),
    });
    if (!res.ok) return null;

    const blob = await res.blob();
    if (blob.size === 0) return null;

    const extension = fileName.split(".").pop().toLowerCase();
    const mimeType = IMAGE_MIME_TYPES[extension];
    return URL.createObjectURL(
      mimeType ? blob.slice(0, blob.size, mimeType) : blob
    );
  } catch (err) {
    console.log("fetchProfilePhoto failed", err);
    return null;
  }
}
async function getTicketMainCategory() {
  let res = await fetch(main_url + "helpDesk/getTicketMainCategory", {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}

async function getTicketSubCategory() {
  let res = await fetch(main_url + "helpDesk/getTicketSubCategory", {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}

async function getTicketStatus() {
  let res = await fetch(main_url + "helpDesk/getTicketStatus", {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}

// async function getOpenClose() {
//     let res = await fetch(main_url + "helpDesk/getOpenClose")
//     if (res.ok)
//         return res.json()
//     else return []
// }

async function getPriority() {
  let res = await fetch(main_url + "helpDesk/getPriority", {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}

async function getSeverity() {
  let res = await fetch(main_url + "helpDesk/getSeverity", {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}

async function getBranchByHelpDesk() {
  let res = await fetch(main_url + "helpDesk/getBranch", {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}

async function getWorkFlowStatus(request_id, user_id, title, type) {
  let res = await fetch(
    `${main_url}main/getWorkFlowStatus/${request_id}/${user_id}/${title}/${type}`,
    {
      headers: getHeaders(),
    }
  );

  if (res.ok) {
    return await res.json();
  } else return { check_by: 0, verify_by: 0, approve_by: 0 };
}

async function getPermissionStatus(designations_id, title, type) {
  let res = await fetch(
    `${main_url}main/getPermissionStatus/${designations_id}/${title}/${type}`,
    {
      headers: getHeaders(),
    }
  );

  if (res.ok) return res.json();
  else return { isAddNew: 0, isEdit: 0, isView: 0 };
}

async function getMaritalStatus(user_id) {
  let res = await fetch(`${main_url}main/getUserInfo/${user_id}`, {
    headers: getHeaders(),
  });

  if (res.ok) {
    let info = await res.json();
    return info.length > 0 ? info[0].maratial_status : null;
  } else return null;
}

function validate(id) {
  var errorlist = [];
  var formid = `#${id}`;
  var check_inputid = formid + " input.checkValidate";
  var check_divid =
    formid + " div.checkValidate .react-select__value-container";
  var check_txtareaid = formid + " textarea.checkValidate";
  var inputlist = document.querySelectorAll(check_inputid);
  var divlist = document.querySelectorAll(check_divid);
  var txtarealist = document.querySelectorAll(check_txtareaid);
  for (let i = 0; i < txtarealist.length; i++) {
    if (txtarealist[i].value.trim() === "" || txtarealist[i].value === "0") {
      txtarealist[i].style.border = "1px solid red";
      errorlist.push({
        status: false,
      });
    } else {
      txtarealist[i].style.border = "1px solid #eee";
      errorlist.push({
        status: true,
      });
    }
  }
  for (let i = 0; i < inputlist.length; i++) {
    if (inputlist[i].value.trim() === "" || inputlist[i].value == 0) {
      inputlist[i].style.border = "1px solid red";
      errorlist.push({
        status: false,
      });
    } else {
      inputlist[i].style.border = "1px solid #eee";
      errorlist.push({
        status: true,
      });
    }
  }
  for (let i = 0; i < divlist.length; i++) {
    let par = divlist[i];
    let notes = null;
    for (let i = 0; i < par.childNodes.length; i++) {
      if (
        par.childNodes[i].className ===
        "react-select__single-value css-1uccc91-singleValue"
      ) {
        notes = par.childNodes[i].innerHTML;
        break;
      }
    }
    if (notes === null) {
      par.parentElement.style.border = "1px solid red";
      errorlist.push({
        status: false,
      });
    } else {
      par.parentElement.style.border = "1px solid #eee";
      errorlist.push({
        status: true,
      });
    }
  }
  let status = true;
  for (let i = 0; i < errorlist.length; i++) {
    if (errorlist[i].status === false) {
      status = false;
      break;
    } else {
      status = true;
    }
  }
  if (status === true) {
    return true;
  } else return false;
}

async function getDepartment() {
  var res = await fetch(`${main_url}main/getDepartment`, {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}

async function getDesignationList() {
  var res = await fetch(`${main_url}main/getDesignations`, {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}

// Added by STHA New CRN
async function getAllEmployeeCode() {
  var res = await fetch(`${main_url}employee/getEmployeeCode`, {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}

function havePermissionForAmount(status, user_id) {
  let user_info = getCookieData("user_info");
  if (
    (status.check_by > 0 ||
      status.verify_by > 0 ||
      status.approve_by > 0 ||
      user_info.designations === "CEO") &&
    user_id !== user_info.user_id
  ) {
    return true;
  } else {
    return false;
  }
}

function getNumberWithCommas(data) {
  return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function havePermission(status, user_id) {
  console.log("have permission", status, user_id);
  let user_info = getCookieData("user_info");
  if (user_id && user_id == user_info.user_id) {
    console.log("if condition");
    return false;
  } else {
    if (
      status.check_by > 0 ||
      status.verify_by > 0 ||
      status.approve_by > 0 ||
      user_info.designations === "CEO"
    ) {
      return true;
    } else {
      return false;
    }
  }
}

function isApprover(user_id) {
  var user = getCookieData("user_info");
  if (user.user_id !== user_id) return true;
  else return false;
}

async function getInformation(path, id) {
  var res = await fetch(`${main_url}${path}/getOneDetailInfo/${id}`, {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}

async function getLimitAmount() {
  if (limit_amounts.default > 0) return limit_amounts.default;
  else {
    var res = await fetch(`${main_url}main/getLimitAmount`, {
      headers: getHeaders(),
    });
    if (res.ok) return res.json();
    else return 0;
  }
}

// Added by LMM for Travel Approval Permission Changes (27 Aug 2024)
function checkAmountHRManager(amount, purpose) {
  var user = getCookieData("user_info");
  if (!Object.keys(limit_amounts).includes(purpose)) {
    return (
      amount <= limit_amounts.default && user.designations === "HR Manager"
    );
  } else {
    return (
      amount > limit_amounts[purpose].base &&
      amount <= limit_amounts[purpose].top &&
      user.designations === "HR Manager"
    );
  }
}

function checkAmount(amount, purpose) {
  var user = getCookieData("user_info");
  let limitAmount;
  if (!Object.keys(limit_amounts).includes(purpose)) {
    limitAmount = limit_amounts.default;
  } else {
    limitAmount = limit_amounts[purpose].top;
  }
  if (amount > limitAmount && (user.designations === "CEO" || user.designations === "COO")) return true;
  else return false;
}

function checkLimitAmount(amount, purpose) {
  let limitAmount;
  if (!Object.keys(limit_amounts).includes(purpose)) {
    limitAmount = limit_amounts.default;
  } else {
    limitAmount = limit_amounts[purpose].base;
  }
  if (amount > limitAmount) return false;
  else return true;
}

function checkHRManager() {
  var user = getCookieData("user_info");
  if (user.designations === "HR Manager") return true;
  else return false;
}

function checkHRAssistant() {
  var user = getCookieData("user_info");
  if (user.designations === "HR Assistant") return true;
  else return false;
}
async function setPrintedStatus(path, id) {
  var res = await fetch(`${main_url}${path}/setPrintedStatus/${id}`, {
    headers: getHeaders(),
  });
  if (res.ok) {
    window.location.reload();
  }
}

function stopSaving() {
  $("#saving_button").attr("disabled", true);
  // toast.error("Please Choose Attachment File!");
}

function startSaving() {
  $("#saving_button").attr("disabled", false);
}

const atten_report = {
  work: 1,
  work_in_holiday: 2,
  work_in_pholiday: 3,
  approve_leave: 4,
  not_approve_leave: 5,
  absent: 6,
  holiday: 7,
  pholiday: 8,
};

async function getAttendancePolicy() {
  var res = await fetch(`${main_url}attendancePolicy/getAttendancePolicy`, {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}

async function getDesignationData() {
  var res = await fetch(`${main_url}designation/getDesignation`, {
    headers: getHeaders(),
  });
  if (res.ok) return res.json();
  else return [];
}
async function getMonthName(monthNumber) {
  console.log("month number", monthNumber);
  const date = new Date();
  date.setMonth(monthNumber - 1);

  return date.toLocaleString("en-US", {
    month: "short",
  });
}

async function handleLoginCall(formdata) {
  console.log("Here is data", formdata);
  fetch(main_url + "main/hrmLogin", {
    method: "POST",
    headers: getHeaders(false),
    body: JSON.stringify(formdata),
  })
    .then((data) => {
      // console.log("Here is user data", data);
      return data;
    })
    .catch((err) => {
      // toast.error(err);
      return null;
    });
}

function isLeapYear(year) {
  let is_leap_year = false;
  year % 4 === 0 ? (is_leap_year = true) : (is_leap_year = false);
  return is_leap_year;
}

function monthName(month) {
  switch (month) {
    case 1:
      return "January";
    case 2:
      return "February";
    case 3:
      return "March";
    case 4:
      return "April";
    case 5:
      return "May";
    case 6:
      return "June";
    case 7:
      return "July";
    case 8:
      return "August";
    case 9:
      return "September";
    case 10:
      return "October";
    case 11:
      return "November";
    case 12:
      return "December";
    default:
      return undefined;
  }
}

function leaveApplicationStatusBadge(status, previousStatus) {
  if (status === 0) {
    return '<small class="label label-warning" style="background-color:#509aed"> Request </small>';
  } else if (status === 1) {
    return '<small class="label label-warning" style="background-color:#509aed"> Request </small>';
  } else if (status === 2) {
    return '<small class="label label-warning" style="background-color:#f2a509"> Verify </small>';
  } else if (status === 3) {
    return '<small class="label label-warning" style="background-color:#29a50a"> Approve </small>';
  } else if (status === 4) {
    return '<small class="label label-warning" style="background-color:#f60e2f"> Reject </small>';
  } else if (status === 5) {
    return '<small class="label label-warning" style="background-color:#cc0066"> Refer Back </small>';
  } else {
    if (previousStatus === 3) {
      return '<small class="label label-warning" style="background-color:#29a50a"> Approve </small>';
    } else if (previousStatus === 5) {
      return '<small class="label label-warning" style="background-color:#cc0066"> Refer Back </small>';
    } else if (previousStatus === 2) {
      return '<small class="label label-warning" style="background-color:#f2a509"> Verify </small>';
    } else if (previousStatus === 1) {
      return '<small class="label label-warning" style="background-color:#509aed"> Request </small>';
    } else {
      return '<small class="label label-warning" style="background-color:#f60e2f"> Reject </small>';
    }
  }
}

function leaveApplicationCancelStatusBadge(
  status,
  cancelReject,
  cancelApprove,
  cancelVerify,
  cancelApplyDate
) {
  if (status === 6) {
    return '<small class="label label-warning" style="background-color:#eb6b1c"> Cancel Request </small>';
  } else if (status === 7) {
    return '<small class="label label-warning" style="background-color:#eb6b1c"> Cancel Verify</small>';
  } else if (status === 8) {
    return '<small class="label label-warning" style="background-color:#eb6b1c"> Cancel Approve</small>';
  } else if (status === 9) {
    return '<small class="label label-warning" style="background-color:#eb6b1c"> Cancel Reject</small>';
  } else {
    if (cancelReject) {
      return '<small class="label label-warning" style="background-color:#eb6b1c"> Cancel Reject</small>';
    } else if (cancelApprove !== null) {
      return '<small class="label label-warning" style="background-color:#eb6b1c"> Cancel Approve</small>';
    } else if (cancelVerify !== null) {
      return '<small class="label label-warning" style="background-color:#eb6b1c"> Cancel Verify</small>';
    } else if (cancelApplyDate !== null) {
      return '<small class="label label-warning" style="background-color:#eb6b1c"> Cancel Request </small>';
    } else {
      return "";
    }
  }
}

function validatePhoneNumberInput(currVal, newVal) {
  if (currVal && currVal.length === 1 && newVal.length < 1) {
    return false;
  }
  if (newVal.length > 10) {
    return false;
  }
  return true;
}

function validatePhoneNumber(number, phoneName) {
  if (!number) return `Please enter ${phoneName}.`;
  if (number.length < 8) return `${phoneName} must have at least 8 digits.`;
  if (number.length > 10) {
    return `${phoneName} must not exceed 10 digits.`;
  }
  if (!number.startsWith("9")) {
    return `${phoneName} must start with 9.`;
  }
}

function validateEmailAddress(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isCorrectFormat = emailRegex.test(email);
  return (
    isCorrectFormat &&
    (email.endsWith("@gmail.com") || email.endsWith("@alliance-mm.com"))
  );
}

export {
  isLeapYear,
  handleLoginCall,
  main_url,
  remote_url,
  getUserInfo,
  setCookieData,
  getCookieData,
  getUserId,
  getActionStatus,
  getDesignation,
  getBranch,
  getWithdrawalLocation,
  getHRMSStatus, // Added by STHA
  getTicketCategoryType,
  getRegion,
  getTrainingVenue,
  getMainRole,
  getPermissionStatus,
  getSeverity,
  getPersonType,
  getBranchByHelpDesk,
  getPriority,
  getTicketStatus,
  getTicketMainCategory,
  getTicketSubCategory,
  validate,
  checkForStaffComplain,
  getDepartment,
  getDesignationList, //Added by STHA
  getAllEmployeeCode, // Added by STHA
  getWorkFlowStatus,
  getCOEmployeeList,
  getFXEmployeeList,
  alertText,
  getNumberWithCommas,
  getLevel,
  havePermission,
  getInformation,
  checkAmountHRManager,
  checkAmount,
  setPrintedStatus,
  removeCookieData,
  getLoginUser,
  handleLogin,
  getUserInfoLogin,
  print,
  stopSaving,
  startSaving,
  fno,
  getFirstDayOfMonth,
  getFirstDayOfYear,
  checkLimitAmount,
  checkHRManager,
  checkHRAssistant,
  checkApprovalStatus,
  isApprover,
  havePermissionForAmount,
  calculationDate,
  isRequestedUser,
  atten_report,
  approveAmount,
  calculationDate1,
  getAttendancePolicy,
  getAttendanceReason,
  getDesignationData,
  calculationWorkingExp,
  getLastDayOfMonth,
  imageError,
  getErrorMessage,
  fetchProfilePhoto,
  FALLBACK_AVATAR,
  getFirstDayOfPrevMonth,
  getFirstDayOfNextMonth,
  getFirstDayOfNextTwoMonth,
  getMonth,
  getFirstDayOfCurrentWeek,
  getMonthName,
  calculationDate2, // Added by STHA
  setLoginUserInfo, // Added by STHA
  getLoginUserInfo, // Added by STHA
  monthName,
  leaveApplicationStatusBadge,
  leaveApplicationCancelStatusBadge,
  validatePhoneNumberInput,
  validatePhoneNumber,
  validateEmailAddress,
  MARITAL_STATUS_OPTIONS,
  getMaritalStatus,
};
